(function () {
  if (window.__cartViewAlertInitialized) return;
  window.__cartViewAlertInitialized = true;

  function initCartViewAlert() {
    var configEl = document.getElementById('cart-view-alert-config');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (!config.enabled) return;

    var productHandle = getProductHandle(config.productHandle);
    var randomCount = getOrGenerateCount(productHandle, config);
    var message = (config.message || '{{count}} people viewed this product in the last 24 hours').replace(
      /\{\{count\}\}/g,
      String(randomCount)
    );

    var container = document.createElement('div');
    container.className = 'cart-alert-box';
    if (config.backgroundColor) {
      container.style.setProperty('--cart-alert-bg', config.backgroundColor);
    }
    if (config.textColor) {
      container.style.setProperty('--cart-alert-color', config.textColor);
    }

    container.innerHTML = buildIconHtml(config) + '<span class="cart-message">' + escapeHtml(message) + '</span>';

    var target = document.getElementById('buy_buttons_flag');
    if (target) {
      target.insertAdjacentElement('afterend', container);
    }
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function buildIconHtml(config) {
    var icon = (config.icon || 'cart').trim();
    var modifier = icon === 'eye' ? 'eye' : 'cart';

    if (config.iconUrl) {
      return (
        '<span class="cart-icon cart-icon--' +
        modifier +
        '">' +
        '<img src="' +
        escapeHtml(config.iconUrl) +
        '" alt="" width="20" height="20">' +
        '</span>'
      );
    }

    return '<span class="cart-icon cart-icon--cart">' + escapeHtml('🛒') + '</span>';
  }

  function getProductHandle(fallbackHandle) {
    if (fallbackHandle) return fallbackHandle;

    var pathParts = window.location.pathname.split('/');
    var productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts[productsIndex + 1]) {
      return pathParts[productsIndex + 1];
    }

    if (window.product && window.product.handle) {
      return window.product.handle;
    }

    if (window.meta && window.meta.product && window.meta.product.handle) {
      return window.meta.product.handle;
    }

    var productTitle = document.querySelector('.product-single__title, h1.product-title');
    if (productTitle && productTitle.innerText) {
      return productTitle.innerText.replace(/\s+/g, '-').toLowerCase();
    }

    return window.location.pathname;
  }

  function getOrGenerateCount(productHandle, config) {
    var storageKey = 'cart_alert_count_' + productHandle;
    var timestampKey = 'cart_alert_timestamp_' + productHandle;
    var sessionDuration = (config.sessionMinutes || 30) * 60 * 1000;

    var storedCount = sessionStorage.getItem(storageKey);
    var storedTimestamp = sessionStorage.getItem(timestampKey);
    var now = Date.now();

    if (storedCount && storedTimestamp && now - parseInt(storedTimestamp, 10) < sessionDuration) {
      return parseInt(storedCount, 10);
    }

    var min = config.defaultMin;
    var max = config.defaultMax;

    var productConfigs = config.productConfigs;
    if (typeof productConfigs === 'string') {
      try {
        productConfigs = JSON.parse(productConfigs);
      } catch (e) {
        productConfigs = {};
      }
    }
    if (!productConfigs || typeof productConfigs !== 'object') {
      productConfigs = {};
    }

    if (config.productMin != null && config.productMax != null) {
      min = config.productMin;
      max = config.productMax;
    } else if (productConfigs[productHandle]) {
      min = productConfigs[productHandle].min;
      max = productConfigs[productHandle].max;
    }

    min = parseInt(min, 10);
    max = parseInt(max, 10);
    if (isNaN(min)) min = 25;
    if (isNaN(max)) max = 40;
    if (min > max) {
      var temp = min;
      min = max;
      max = temp;
    }

    var newCount = Math.floor(Math.random() * (max - min + 1)) + min;

    sessionStorage.setItem(storageKey, String(newCount));
    sessionStorage.setItem(timestampKey, String(now));

    return newCount;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartViewAlert);
  } else {
    initCartViewAlert();
  }
})();
